var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 15.7168C11.7143 15.1784 12.0197 14.705 12.4252 14.3866C13.3824 13.6348 14 12.4488 14 11.1144C14 8.84208 12.2091 7 10 7C7.79086 7 6 8.84208 6 11.1144C6 12.4488 6.61757 13.6348 7.57476 14.3866C7.98026 14.705 8.28571 15.1784 8.28571 15.7168C8.28571 16.0965 8.57317 16.4044 8.92776 16.4044H11.0722C11.4268 16.4044 11.7143 16.0965 11.7143 15.7168Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15736 18.2507C8.15736 17.8368 8.47066 17.5013 8.85713 17.5013H11.1429C11.5293 17.5013 11.8426 17.8368 11.8426 18.2507C11.8426 18.6645 11.5293 19 11.1429 19H8.85713C8.47066 19 8.15736 18.6645 8.15736 18.2507Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2595 4.25C16.3871 2.57189 17.7892 1.25 19.5 1.25C21.2108 1.25 22.6129 2.57189 22.7405 4.25H22.75V19C22.75 20.5188 21.5188 21.75 20 21.75H4C2.48122 21.75 1.25 20.5188 1.25 19V7C1.25 5.48122 2.48122 4.25 4 4.25H16.2595ZM21.25 15.5C21.25 14.5335 20.4665 13.75 19.5 13.75C18.5335 13.75 17.75 14.5335 17.75 15.5C17.75 15.9142 17.4142 16.25 17 16.25C16.5858 16.25 16.25 15.9142 16.25 15.5V5.75H4C3.30964 5.75 2.75 6.30964 2.75 7V19C2.75 19.6904 3.30964 20.25 4 20.25H20C20.6904 20.25 21.25 19.6904 21.25 19V15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIdea);
export default __webpack_public_path__ + "static/media/letter-idea.d4a28e8c4499c13a544e9b3bc83ea72d.svg";
export { ForwardRef as ReactComponent };